import React, { useEffect } from 'react'
import { DocsMatchUnknowPutAway } from '../DocsMatchUnknowPutAway/DocsMatchUnknowPutAway'
import { ButtonFilter } from './ButtonFilter'
import { useStyles } from './styles'
import { usePutAway } from '../../Context/usePutAway'
import { unknownFilterValues } from '../../types/stepperTypes'
import { putAwayActions } from '../../actions/putAwayActions'
import { putAwayActions as putAwayBusiness } from '../../actions/putAwayBusiness'
import { GenericInputAction } from '../../../UI/GenericInputAction/GenericInputAction'
import StepBackPutAway from '../StepBackPutAway/StepBackPutAway'
import { SupplierButton } from './SupplierButton'
import { ClearAdornment } from '../../../UI/Adornments/ClearAdornment'
import Typography from '@mui/material/Typography'
import { ValidationPutAway } from '../ValidationPutAway/ValidationPutAway'
import { useSuppliers } from '../../../../hooks'
import { useSuppliersOrigin } from '../../../../hooks/useSuppliersOrigin'
import { SwitchPutAwayUnknow } from '../SwitchPutAway/SwitchPutAwayUnknow'

/*
Copyright 2022-07-08 por Jorge Parrado Ecomsur Holding S.A ©
Detalle: Crea logica y acciones para buscar ot desconociendo ID
*/

export const UnknowOt = () => {
  const classes = useStyles()
  const { state } = usePutAway()

  const {
    suppliersState: { suppliers },
    getSuppliers
  } = useSuppliers()
  const {
    suppliersOriginState: { suppliersOrigin },
    getSuppliersOrigin
  } = useSuppliersOrigin()

  const {
    resetButtonFilter,
    handleChangeGenericInput,
    validateSkuUnknown,
    handleResetGenericInput
  } = putAwayActions()
  const { getUnknown } = putAwayBusiness()

  useEffect(() => {
    if (suppliers?.length === 0) {
      getSuppliers()
    }
    if (suppliersOrigin?.length === 0) {
      getSuppliersOrigin()
    }
    getUnknown()
  }, [
    state.unknownFilter,
    state.skuUnknown.status,
    state.headerParamSearchValue
  ])

  useEffect(() => {
    if (state.skuUnknown.value.length === 0) {
      handleResetGenericInput('setSkuUnknown')
    }
  }, [state.skuUnknown.value])

  const adornment = (
    <ClearAdornment
      onClick={() => handleResetGenericInput('setSkuUnknown')}
      disabled={state.skuUnknown.value.length === 0}
    />
  )

  return (
    <div className={classes.flexContainer}>
      <StepBackPutAway />
      <span
        style={{
          textAlign: 'left',
          width: '100%',
          marginTop: '40px',
          marginBottom: '20px'
        }}
      >
        <Typography variant='body1'> Buscar por: </Typography>
      </span>
      <span
        style={{
          marginBottom: '20px'
        }}
      >
        <SwitchPutAwayUnknow />
      </span>

      <div className={classes.BtnsContainer}>
        {unknownFilterValues.map(({ text, value }) => (
          <ButtonFilter
            key={text}
            isSelected={value === state.unknownFilter}
            text={text}
            onClick={() => resetButtonFilter(value)}
          />
        ))}

        {suppliers?.length! > 1 && (
          <ButtonFilter
            key={'Proveedor'}
            isSelected={state.unknownFilter === 3}
            text={'Proveedor'}
            onClick={() => resetButtonFilter(3)}
          />
        )}
        {suppliersOrigin?.length! > 1 && (
          <ButtonFilter
            key={'Origen'}
            isSelected={state.unknownFilter === 4}
            text={'Origen'}
            onClick={() => resetButtonFilter(4)}
          />
        )}
      </div>
      <ValidationPutAway />
      {state.unknownFilter === 2 && (
        <form
          onSubmit={(e) => validateSkuUnknown(e)}
          style={{ marginTop: '20px' }}
        >
          <GenericInputAction
            name='skuUnknown'
            id='skuUnknown'
            onChange={(e) => handleChangeGenericInput(e, 'setSkuUnknown')}
            placeholder='Escanea SKU'
            value={state.skuUnknown.value}
            adornment={adornment}
            status={state.skuUnknown.status}
            error={state.skuUnknown.error.length > 0}
            errorText={state.skuUnknown.error}
          />
        </form>
      )}
      {state.unknownFilter < 3 && <DocsMatchUnknowPutAway />}
      {state.unknownFilter >= 3 && <SupplierButton />}
    </div>
  )
}
